import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import { GetKey, GetText } from "../../../../Helpers/GetKey";
import { ValOnlyNumber } from "../../../../Validators/ValOnlyNumber";
import { Moneda } from "../../../../Helpers/Moneda";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FeaturedPlayList } from "@mui/icons-material";
import PercentIcon from '@mui/icons-material/Percent';
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import MedioContactoModal from "./MedioContactoModal";

const AgregarReestructuracionModal = ({ open, onClose, facturasSeleccionadas, saldo, moratorios, interespactado, total, mediocontacto, gestion, objecion, responsable, idcliente }) => {
    const { state } = useLocation();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [evidencia, setEvidencia] = useState({
        documento: "",
        extension: "",
    })

    const [reestructuracion, setReestructuracion] = useState({
        monto: 0,
        fechaconvenio: "",
        volvercontactar: false,
        fechanvolveracontactar: "",
        mediocontacto: "T",
        descuento: 0,
        razon_descuento: "",
        responsable: "",
        idresponsable: responsable,
        ADR: 0,
        firma: "",
        bmonto: false,
        comentarios: ""
    });

    // console.log(state)

    const GetFile = ({ target }) => {
        const file = target.files[0];
        const extension = file.name.split(".").pop().toLowerCase();

        if (file.name.split(".").length > 2) {
            Swal.fire("Clientes", "Archivo inválido", "error");
            target.value = "";
            return;
        }

        if (extension !== "pdf") {
            Swal.fire("Clientes", "Solo se permiten archivos PDF", "error");
            target.value = "";
            return;
        }

        const fReader = new FileReader();
        fReader.readAsDataURL(file);
        fReader.onloadend = function (event) {
            setEvidencia({
                ...evidencia,
                documento: event.target.result,
                extension: extension,
            });
        };
    };

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setReestructuracion({
            ...reestructuracion,
            [prop]: sinComas,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };

    const guardarGestion = () => {
        if (facturasSeleccionadas.length === 0) {
            Swal.fire({
                title: "GESTION DE COBRANZA",
                text: "Debes seleccionar al menos una factura.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio: "*************",
            idcliente: idcliente,
            razon_social: state.razon_social,
            // referencia: info.info.referencia,
            adr: reestructuracion.ADR,
            monto: reestructuracion.monto,
            tipo_credito: reestructuracion.tipo,
            fecha_convenio: "",
            recordatorio: false,
            fecha_recordatorio: "",
            mediocontacto: mediocontacto,
            nombre_usuario: reestructuracion.responsable.toUpperCase(),
            idresponsable: reestructuracion.idresponsable,
            firma: reestructuracion.firma,
            descuento: reestructuracion.descuento,
            razon_descuento: reestructuracion.razon_descuento,
            detalle: JSON.stringify(facturasSeleccionadas),
            gestion: gestion,
            objecion: objecion,
            comentarios: reestructuracion.comentarios,
            volvercontactar: reestructuracion.volvercontactar,
            fechavolveracontactar: reestructuracion.fechanvolveracontactar,
            saldo: saldo,
            moratorios: moratorios,
            interespactado: interespactado,
            total: total,
            comentario_reestructuracion: reestructuracion.comentarios,
            documento_reestructuracion: evidencia.documento,
            extension: evidencia.extension
        };
        request
            .post(`GuardarReestructuracionGestion/Guardar`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "GESTION DE COBRANZA",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("GESTION DE COBRANZA", JSON.stringify(error), "error");
            });
    };
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="generar-convenio-modal-formulario">
                    <div className="generar-convenio-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={state.razonsocial}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`generar-convenio-modal-agregar-convenio`}>
                                    <div className="generar-convenio-modal-agregar-convenio-container scroll-4">
                                        <h3 className="titulo-seccion">Realizar Reestructuración</h3>
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Comentario"
                                            multiline
                                            rows={5}
                                            sx={{ mt: 2 }}
                                            value={reestructuracion.comentarios}
                                            onChange={(e) => {
                                                setReestructuracion({
                                                    ...reestructuracion,
                                                    comentarios: e.target.value,
                                                });
                                            }}
                                        />
                                        <TextField
                                            id="clientes-documento"
                                            type="file"
                                            onChange={GetFile}
                                            sx={{ mt: 1 }}
                                        />
                                    </div>

                                    <div className="generar-convenio-modal-buttons">
                                        {/* <button
                                            className="generar-convenio-modal-button-pdf"
                                        // onClick={() => guardarGestion()}
                                        >
                                            Agregar PDF
                                        </button> */}
                                        <button
                                            className="generar-convenio-modal-button-guardar"
                                            onClick={() => guardarGestion()}
                                        >
                                            Enviar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal >
        </>
    );
};

export default AgregarReestructuracionModal;